import { Button, Modal } from 'AWS-UI-Components-React';
import React from 'react';
import { ErrorFlash } from '../../content/error_flash';
import { OPERATION_STATUS } from '../common/constants';
import { GlMetricTable } from './gl_metric_table';

export class AsinMetricModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      glInfo: `GL: ${this.props.gl}`,
      shipMonthInfo: `Ship Month: ${this.props.payload.timeFrame}`,
    }
  }

  render() {
    const {items, loadStatus, displayInMillions} = this.props;
    return (
      <Modal
        onDismiss={() => this.props.onClose()}
        visible={true}
        closeAriaLabel="Close modal"
        size="max"
        footer={
          <Button variant="primary" onClick={this.props.onClose}>Close</Button>
        }
        header={`ASIN Metrics: ${this.props.asin}`}
        content={
          <div>
            {loadStatus === OPERATION_STATUS.FAIL && <ErrorFlash type="ASIN Metrics" />}
            <GlMetricTable tableName="ASIN Metrics"
                           glInfo={this.state.glInfo}
                           shipMonthInfo={this.state.shipMonthInfo}
                           description={this.state.description}
                           items={ items }
                           loading={ loadStatus === OPERATION_STATUS.IN_PROGRESS}
                           displayInMillions={ displayInMillions }
                           payload={this.props.payload}
                           downloadEnabled={true}
                           latestSnapshot={this.props.latestSnapshot}
            />
            {/*<ASINTrendChart data={this.props.trendDataRows} metricName="ASIN Metric"*/}
            {/*                loading={loadStatus === OPERATION_STATUS.IN_PROGRESS}*/}
            {/*                lines={this.props.trendLines} displayInMillions={false} selectedComponent={this.props.component}*/}
            {/*                availableMonths={this.props.availableMonths} compareMonths={false}*/}
            {/*                payload={this.props.payload}*/}
            {/*                snapshotToComponentMetricMap={this.props.snapshotToComponentMetricMap}*/}
            {/*/>*/}
          </div>
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/asin_metric_modal.jsx